import { AuthData } from '../types';

const TOKEN_KEY = 'solar_auth_token';
const USER_KEY = 'solar_user_data';

export const saveAuthData = (authData: AuthData) => {
  localStorage.setItem(TOKEN_KEY, authData.token);
  localStorage.setItem(USER_KEY, JSON.stringify(authData.user));
};

export const setAuthData = (authData: AuthData) => {
  saveAuthData(authData);
};

export const getAuthData = (): AuthData | null => {
  const token = localStorage.getItem(TOKEN_KEY);
  const userData = localStorage.getItem(USER_KEY);
  
  if (token && userData) {
    return {
      token,
      user: JSON.parse(userData)
    };
  }
  return null;
};

export const clearAuthData = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const isAuthenticated = (): boolean => {
  return !!getAuthData();
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};